module.exports = __webpack_public_path__ + "static/media/inviteSuccess.3e38ea79.png";